import { Link, graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

interface Props {
  type: "apple" | "google"
}

export const AppStoreButton = (props: Props) => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityBasicSettings {
        androidAppUrl
        iosAppUrl
      }
    }
  `);

  const data = rawData.sanityBasicSettings

  return (
    <Link to={props.type == "apple" ? data.iosAppUrl : data.androidAppUrl} className="flex items-center space-x-4 px-5 py-3 bg-white bg-opacity-10 rounded-full text-sm">
      {props.type == "apple" && <StaticImage width={17} src="../images/app-store.png" alt="" />}
      {props.type == "apple" && <span>Play store</span>}
      {/*  */}
      {props.type == "google" && <StaticImage width={17} src="../images/google-play.png" alt="" />}
      {props.type == "google" && <span>App store</span>}
    </Link>
  );
};
